/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { getHasSavedResults } from 'ctm-selectors/selectors/results';
import { apiAction, pageContext, sortAndMutatePdsData, get } from 'ctm-util-functions';
import { quoteIdSelector } from 'ctm-selectors';

import { getFeatureFlag } from 'ctm-selectors/selectors/base';
import { Anchor } from '../../anchor/anchor';
import { InternalLink } from '../../internal_link/internal_link';

import * as actions from '../actions';

import styles from './results_link_pds.css';

class _ResultsLinkPDS extends Component {

    /**
     *
     * @param {Object} event The event object
     */
    handleClick = (event) => {
        const { dispatch, onClickMoreInfo, moreInfoHref, stateProps, quoteId, api } = this.props;

        // @todo EVT-481 this whole method should be abstracted as its called from multiple places.
        const productId = get(stateProps, 'product.productMeta.id');
        dispatch(actions.setProductId(productId));
        dispatch(actions.setQuoteId(quoteId));

        // Dispatch any other onClick action defined in schema
        if (onClickMoreInfo) {
            dispatch(onClickMoreInfo);
        }

        if (api) {
            if (!moreInfoHref) {
                event.preventDefault();
            }
            dispatch(apiAction(api, pageContext.getProps().pageState));
        }
    };

    /**
     * Construct and return a unique data-id attribute value for this resultsLink, using elementProps.dataIdBase
     * and the productId for this link
     * @returns {String} - The value for the data-id attribute
     * @private
     */
    _getDataId = () => {
        const { moreInfoDataIdBase, stateProps } = this.props;
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props['data-id']) {
            // eslint-disable-next-line react/destructuring-assignment
            return this.props['data-id'];
        }

        const productId = stateProps.product.getIn(['productMeta', 'id']);
        const baseId = moreInfoDataIdBase;
        return `${baseId}.${productId}`;
    };

    renderPDSLinksHome = (productDisclosures, product) => {
        const pdsa = productDisclosures.get('pdsa');
        const pdsb = productDisclosures.get('pdsb');

        /**
         * Checks if the provider code of the given product is 'CHU'.
         *
         * @return {boolean} Returns true if the provider code is 'CHU', otherwise false.
         */
        const isChu = () => {
            return product.get('providerMeta').get('code') === 'CHU';
        };

        const links = [];

        if (pdsa) {
            links.push({
                href: pdsa,
                title: `${isChu() ? 'PDS' : 'PDS A'}`,
                key: 'pds.A'
            });
        }

        if (pdsb && !isChu()) {
            const char = pdsa ? 'B' : 'A';
            links.push({
                href: pdsb,
                title: `PDS ${char}`,
                key: `pds.${char}`
            });
        }

        return Immutable.fromJS(links);
    };

    renderPDSLinksCar = (productDisclosures) => sortAndMutatePdsData(productDisclosures, 'min');

    getPDSData = () => {
        const { vertical, stateProps } = this.props;
        const { product } = stateProps;
        const productDisclosures = product.getIn(['productMeta', 'productDisclosures']);
        switch (vertical) {
            case 'home-contents-insurance':
                return this.renderPDSLinksHome(productDisclosures, product);
            case 'car-insurance':
                return this.renderPDSLinksCar(productDisclosures);
            default:
                return Immutable.List();
        }
    };

    renderPDSLinks = () => {
        let pdsLinks = this.getPDSData();
        const hasSpds = pdsLinks.find((pds) => pds.get('code') === 'spds');
        if (hasSpds) {
            pdsLinks = pdsLinks.filter((pds) => pds.get('code') !== 'ped');
        }

        const { vertical } = this.props;
        return pdsLinks.map((pds, index) => (
            <Fragment key={pds.get('key')}>
                {index ? <label> | </label> : null}
                <Anchor href={pds.get(vertical === 'home-contents-insurance' ? 'href' : 'url')} target="_blank" className={styles.pds_link} data-id={this._getDataId()}>
                    <label>{`${pdsLinks.size > 1 || pds.get('code') === 'PEG' || pds.get('code') === 'PDS' ? pds.get('title') : ' PDS'}`}</label>
                </Anchor>
            </Fragment>
        ));
    };

    render = () => {
        const { moreInfoHref, moreInfoDataIdBase, stateProps, modalProps = {} } = this.props;
        const { product } = stateProps;

        const hasSavedResults = getHasSavedResults() || getFeatureFlag('prefillHasSavedResults');
        const vertical = pageContext.getVertical();

        if (!stateProps.product.get('productMeta')) {
            return null;
        }

        return (
            <div>
                {hasSavedResults ? null : (
                    <div>
                        <InternalLink
                            dataIdBase={moreInfoDataIdBase}
                            label="Key information"
                            data-id={this._getDataId()}
                            href={moreInfoHref || '#'}
                            onClick={this.handleClick}
                        />
                    </div>
                )}
                <div>
                    <Anchor href={product.getIn(['productMeta', 'productSuitability'])} target="_blank">
                        Is this product suitable for me?
                    </Anchor>
                </div>
                <div>
                    {this.renderPDSLinks()}
                </div>
            </div>
        );
    };

}

_ResultsLinkPDS.propTypes = {
    stateProps: PropTypes.shape({
        product: PropTypes.instanceOf(Immutable.Map)
    }),
    moreInfoHref: PropTypes.string,
    moreInfoDataIdBase: PropTypes.string,
    onClickMoreInfo: PropTypes.object,
    api: PropTypes.object,
    dispatch: PropTypes.func,
    quoteId: PropTypes.number,
    'data-id': PropTypes.string,
    vertical: PropTypes.string,
    modalProps: PropTypes.shape({
        openComponent: PropTypes.array,
        stateProps: PropTypes.object
    })
};

_ResultsLinkPDS.defaultProps = {
    stateProps: {
        product: Immutable.Map()
    }
};

const mapStateToProps = (state, props) => {
    const quoteId = quoteIdSelector(state) || 0;
    return {
        quoteId,
        vertical: state.getIn(['page', 'vertical'])
    };
};

const ResultsLinkPDS = connect(mapStateToProps)(_ResultsLinkPDS);

export { ResultsLinkPDS, _ResultsLinkPDS };
